/**
 * The CUBE account is valid but its company has no active JARVIS
 * subscription (backend code AUTH_INACTIVE_SUBSCRIPTION). Kept apart from
 * cube-sso.ts so the auth hook can throw it without loading the CUBE SDK.
 */
export class CubeSubscriptionInactiveError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CubeSubscriptionInactiveError';
  }
}
